export default () =>
  import(/* webpackChunkName: "creativePreviwer" */ '@ad/creative-previewer').then(
    res => res.default.CreativePreviewerComponent,
  );
